<template>
    <v-card class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10 ma=0" >
      <v-row justify="center">
        <v-col cols="12" sm="12">
          <info-alert :text="$t('Authenticate.download_formular')" :color="mainColor"/>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12">
          <header-small :text="$t('Check.Files')"></header-small>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12">
          <v-data-table :headers="headers" :items="file" item-key="id" sort-by="name" sortDesc :page.sync="page"
            :items-per-page="itemsPerPage" @page-count="pageCount = $event" class="elevation-1" :footer-props="{
              disableItemsPerPage: true,
              itemsPerPageOptions: [],
              itemsPerPageText: '',
            }">
            <template v-slot:item.actions="{ item }">
              <v-tooltip top key="download">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="custom-icon2" @click="download(item)" v-bind="attrs" v-on="on">
                    mdi-file-download-outline
                  </v-icon>
                </template>
                <span>{{ $t("Tooltips.download") }}</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              {{ $t("Headers.no_data") }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
</template>

<script>
import HeaderMedium from "../../components/ui/text/HeaderMedium.vue";
import i18n from "../../i18n";
import InfoAlert from "../../components/ui/other/InfoAlert";
import HeaderSmall from "../../components/ui/text/HeaderSmall";
import { log } from "@/helpers/logger";

export default {
  name: "qes-identify-exisiting-download",
  components: {
    HeaderMedium,
    HeaderSmall,
    InfoAlert,
  },
  props: ["signer_id"],
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      mainColor: this.$vuetify.theme.themes.light.primary,
      file: [],
      headers: [
        {
          value: "name",
          text: i18n.t("Headers.file_name"),
          sortable: true,
        },
        {
          value: "actions",
          text: "",
        },
      ],
      summaryText: "",
    };
  },
  created() {
    this.$emit("step", 2);
    this.getFile()
  },
  methods: {
    getFile: async function(){   
      let data = {
        signer_id: this.signer_id
      }
      await this.$store
      .dispatch("data/getFileToSign", data)
      .then(async (data) => {
          log(
          "QesIdentifyExisting.index.getFileToSign() - get File to Sign " +
            this.signer_id,
          "info"
          )
          this.file = data;
      })
      .catch((err) => {
          log("QesIdentifyExisting.index.getFileToSign() - " + err, "error");
      });
    },
    async download(file) {
      try {
        this.$store.commit("set_loading", true);
        const linkSource = `data:application/pdf;base64,${file.file}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = file.name;
        downloadLink.click();
        this.$store.commit("set_loading", false);
      } catch (e) {
        this.$store.commit("set_loading", false);
      }
    },
  },
};
</script>